import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CountdownNotificationRef } from './countdown-notification.service';
import { NotificationRef } from '../notification.service';
import { INotificationItem } from '@fi-app/utilities/notification/notification';

@Component({
    selector: 'fi-countdown-notification',
    templateUrl: './countdown-notification.component.html',
    standalone: false,
})
export class FiCountdownNotificationComponent implements OnInit, OnDestroy {
    showTime;
    interval;

    constructor(
        @Inject(CountdownNotificationRef) public countdownNotification: ICountdownNotificationRefData,
        @Inject(NotificationRef) public notiRef: INotificationItem,
    ) {
        this.updateShowTime();
    }

    updateShowTime = () => {
        this.showTime = new Date(1970, 0, 1).setSeconds(this.countdownNotification.countDownTime / 1000);
    };

    ngOnInit() {
        const initialTime = this.countdownNotification.countDownTime;
        const startTime = Date.now();

        this.interval = setInterval(() => {
            if (this.countdownNotification.countDownTime > 0) {
                this.countdownNotification.countDownTime = (startTime + initialTime - Date.now()).toFixed();
                if (this.countdownNotification.countDownTime < 0) {
                    this.countdownNotification.countDownTime = 0;
                }
                this.updateShowTime();
            }

            if (this.countdownNotification.countDownTime <= 0) {
                clearInterval(this.interval);
                this.notiRef.countdownFinished.next();
            }
        }, 1000);
    }

    ngOnDestroy() {
        clearInterval(this.interval);
    }
}
